<template lang="">
  <div class="prop">
    <div
      class="f1"
      :style="{
        backgroundImage: 'url(' + baseUrl + '/shutterstockj.png' + ')',
      }"
    ></div>
    <div class="f2">
      <div class="f2_box">
        <div class="f2_title">VALUE PROPOSITION</div>
        <div class="f2_txt">
          We are a cloud-based AI fintech platform. Our platform aggregates
          consumer demand for high-quality loans, saving with high interest, and
          connects it to our network of TiFi AI-enabled bank and other investor
          partners.<br /><br />
          We leverage the power of AI to more accurately quantify the true risk
          of a loan. Our AI models have been continuously upgraded, trained and
          refined. We have discrete AI models that target fee optimization,
          income fraud, acquisition targeting, loan stacking, prepayment
          prediction, identity fraud and time-delimited default prediction. Our
          models incorporate more than 3,000 variables and benefit from a
          rapidly growing training dataset.
        </div>
      </div>
    </div>
    <div class="f3">
      <div class="f3_box">
        <div class="f3_title">FOR CONSUMERS</div>
        <!-- <div class="f3_list mr140">
          <img :src="baseUrl + '/shutterstockk.png'" alt="" />
          <div class="f3_list_title">01.</div>
          <div class="f3_list_txt">
            When consumers on our platform want to conduct a loan, who will
            benefit from higher approval rates, lower interest rates, and a
            highly automated, efficient, all-digital experience.
          </div>
        </div>
        <div class="f3_list">
          <img :src="baseUrl + '/shutterstockl.png'" alt="" />
          <div class="f3_list_title">02.</div>
          <div class="f3_list_txt">
            We provide a group saving service, based on which consumers can save
            as a group with those share the similar saving plan, in order to
            push for a better saving habit. Meanwhile, the saving behavior will
            increase your credit when you conduct a loan to achieve a higher
            amount or lower interest.
          </div>
        </div> -->
        <div
          class="f3_list2 mr140"
          :style="{
            backgroundImage: 'url(' + baseUrl + '/shutterstockk.png' + ')',
          }"
        >
          <div class="info">
            When consumers on our platform want to conduct a loan, who will
            benefit from higher approval rates, lower interest rates, and a
            highly automated, efficient, all-digital experience.
          </div>
        </div>
        <div
          class="f3_list2"
          :style="{
            backgroundImage: 'url(' + baseUrl + '/shutterstockl.png' + ')',
          }"
        >
          <div class="info">
            We provide a group saving service, based on which consumers can save
            as a group with those share the similar saving plan, in order to
            push for a better saving habit. Meanwhile, the saving behavior will
            increase your credit when you conduct a loan to achieve a higher
            amount or lower interest.
          </div>
        </div>
      </div>
    </div>
    <div class="f4">
      <div class="f4_box">
        <div class="f4_title">FOR BANKS AND INVESTORS</div>
        <div class="f4_list">
          <img :src="baseUrl + '/shutterstockm.png'" alt="" />
          <div class="f4_list_right">
            <!-- <div class="f4_list_right_title">01.</div> -->
            <div class="f4_list_right_txt">
              Our bank and investor partners benefit from access to new
              customers, lower fraud and loss rates, and increased automation
              throughout the lending process.
            </div>
          </div>
        </div>
        <div class="f4_list">
          <img :src="baseUrl + '/shutterstockn.png'" alt="" />
          <div class="f4_list_right">
            <!-- <div class="f4_list_right_title">02.</div> -->
            <div class="f4_list_right_txt">
              We provide cost effective user acquisition to them based on scene,
              such as government officers, house holders, education service
              payers, car owners, in order to ensure a high level of the
              lenders’ quality.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {
    this.$store.commit("SetStatus", "2");
  },
};
</script>
<style lang="scss" scoped>
.prop {
  .f1 {
    width: 100%;
    height: 403px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .f2 {
    width: 100%;
    padding: 80px 0;
    background: #fff;
    .f2_box {
      width: 1200px;
      margin: 0 auto;
      .f2_title {
        font-size: 62px;
        font-family: "oh";
        font-weight: normal;
        color: #f43d3d;
        margin-bottom: 38px;
      }
      .f2_txt {
        width: 870px;
        font-size: 18px;
        font-family: "or";
        font-weight: normal;
        color: #28283c;
        line-height: 35px;
      }
    }
  }
  .f3 {
    width: 100%;
    background-color: #28283c;
    padding: 80px 0 120px;
    .f3_box {
      width: 1200px;
      margin: 0 auto;
      .f3_title {
        font-size: 62px;
        font-family: "oh";
        font-weight: normal;
        color: #f43d3d;
        line-height: 66px;
        margin-bottom: 150px;
      }
      .f3_list {
        width: 530px;
        display: inline-block;
        vertical-align: top;
        &.mr140 {
          margin-right: 140px;
        }
        img {
          width: 530px;
          height: 265px;
          display: block;
          margin-bottom: 40px;
        }
        .f3_list_title {
          font-size: 30px;
          font-family: "oh";
          font-weight: normal;
          color: #f43d3d;
          margin-bottom: 24px;
        }
        .f3_list_txt {
          font-size: 18px;
          font-family: "or";
          font-weight: normal;
          color: #ffffff;
          line-height: 30px;
        }
      }
      .f3_list2 {
        position: relative;
        width: 530px;
        height: 270px;
        display: inline-block;
        vertical-align: top;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        cursor: pointer;
        &.mr140 {
          margin-right: 140px;
        }
        .info {
          font-size: 20px;
          font-family: "or";
          font-weight: normal;
          line-height: 30px;
          height: 62px;
          position: absolute;
          background-color: rgba(255, 255, 255, 0.9);
          bottom: 0;
          left: 0;
          width: 100%;
          padding: 16px 5%;
          box-sizing: border-box;
          color: #000;
          transition: all 0.5s;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        &:hover .info {
          height: 100%;
          display: flex;
          align-items: center;
          overflow: visible;
          white-space: normal;
        }
      }
    }
  }
  .f4 {
    width: 100%;
    padding: 80px 0 110px;
    background: #fff;
    .f4_box {
      width: 1200px;
      margin: 0 auto;
      .f4_title {
        font-size: 62px;
        font-family: "oh";
        font-weight: normal;
        color: #f43d3d;
        line-height: 66px;
        margin-bottom: 100px;
      }
      .f4_list {
        width: 100%;
        margin-bottom: 50px;
        img {
          width: 530px;
          height: 265px;
          display: inline-block;
          vertical-align: top;
          margin-right: 140px;
        }
        .f4_list_right {
          display: inline-block;
          width: 530px;
          vertical-align: top;
          .f4_list_right_title {
            font-size: 30px;
            font-family: "oh";
            font-weight: normal;
            color: #f43d3d;
            margin-bottom: 24px;
          }
          .f4_list_right_txt {
            font-size: 18px;
            font-family: "or";
            font-weight: normal;
            color: #28283c;
            line-height: 30px;
          }
        }
      }
    }
  }
}
</style>
